import { monteurApi } from '../common/monteur-api';
export var workOrdersApi = monteurApi
    .enhanceEndpoints({
    addTagTypes: ['WorkOrders', 'TechnicianWorkOrders']
})
    .injectEndpoints({
    endpoints: function (builder) { return ({
        getWorkOrdersByTechnician: builder.query({
            query: function (query) { return ({
                url: "WorkOrder/get-by-technician-id?technicianId=".concat(query.technicianId, "&page=").concat(query.page, "&pageSize=").concat(query.pageSize)
            }); },
            providesTags: ['TechnicianWorkOrders']
        }),
        getPaginatedWorkOrders: builder.query({
            query: function (query) { return ({
                url: "WorkOrder/get-paginated?page=".concat(query.page, "&pageSize=").concat(query.pageSize),
                method: 'GET'
            }); },
            providesTags: ['WorkOrders']
        })
    }); }
});
export var useGetWorkOrdersByTechnicianQuery = workOrdersApi.useGetWorkOrdersByTechnicianQuery, useGetPaginatedWorkOrdersQuery = workOrdersApi.useGetPaginatedWorkOrdersQuery;
